import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { merge, of as observableOf, of, Subscription } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';

import { API, BUCKETS } from 'src/app/configs';
import { HttpService } from 'src/app/core/http/http.service';

import { GeneralService } from 'src/app/shared/services/general.service';
import { Person } from '../../models/person';
import { PersonService } from '../../services/person.service';
import { VimeoService } from 'src/app/core/services/vimeo.service';
import { AppLoadingService } from '../../services/apploading.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Pagination } from '../../utils/pagination';
import { PostsService } from '../posts/posts.service';
import { DateToString } from 'src/app/core/pipe/pipe-date';
import { deepCopy } from '@angular-devkit/core/src/utils/object';

@Component({
  selector: 'site',
  templateUrl: './site.component.html',
  styleUrls: ['./site.component.scss']
})
export class SiteComponent implements OnInit, OnDestroy {

  tabActive = 'posts';

  companieSelData: any = {};

  mediaTags: any = [];
  mediaTagsIds: any = [];

  isAdmin = false;

  folderAssets = '';

  @ViewChild(MatPaginator) paginator: MatPaginator;

  listLoading = false;

  displayedColumns: string[] = ['type_id', 'cover', 'title', 'source', 'date', 'status'];
  columnsToDisplay: string[] = this.displayedColumns.slice();

  data: MatTableDataSource<any> = new MatTableDataSource<any>();

  postsLength = 0;
  isRateLimitReached = false;

  requestLoadingList = true;


  postsLoading = false;

  formGroup: FormGroup;

  person: any = {};

  siteFiles: any = [];
  siteList: any = [];
  siteSel: any = false;
  siteSettingsCustom: any = {};
  siteSettings: any = {};
  siteStatus = {
    '1': { 'title': 'Ativo' },
    '0': { 'title': 'Em desenvolvimento' },
    '-1': { 'title': 'Inativo' },
    '-5': { 'title': 'Removido' }
  };
  settingsLoading: any = true;

  loading: any = true;

  generalSubscription: Subscription;

  protected companieSelSubscription: Subscription;
  protected transactionDataSubscription: Subscription;
  protected userdataSubscription: Subscription;
  protected filesSubscription: Subscription;
  protected transactionsSubscription: Subscription;

  constructor(
    public gs: GeneralService,
    protected httpService: HttpService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    protected vimeoService: VimeoService,
    protected als: AppLoadingService,
    protected ps: PostsService
  ) {

    this.folderAssets = this.gs.getAssetsFolder();

  }

  ngOnInit() {
    this.companieSelSubscription = this.gs.companiesSel$.subscribe(async result => {
      this.companieSelData = this.gs.getCompanieData(result);
      this.companieSelData.person_id = result;
      await this.loadSiteList();

    });

    this.filesSubscription = this.gs.filesChangeSubscription$.subscribe(async result => {

      if (!!result?.files?.length && result?.action != 'setFiles') {
        this.updateSettings(result.files);
      }
    });

    this.transactionsSubscription = this.gs.transactionData$.subscribe(async result => {
      if (result?.action == 'postsReload') {
          this.refresh();
      }

      if(result)
        this.gs.transactionData.next(null);
    });

    this.formGroup = this.formBuilder.group({
      json: ['{}']
    });

    this.isAdmin = this.gs.getProfiledata().perfil_id == '1';

  }

  ngOnDestroy() {
    this.filesSubscription?.unsubscribe();
    this.companieSelSubscription?.unsubscribe();
    this.transactionsSubscription?.unsubscribe();
  }

  async loadSiteList(): Promise<any> {
    this.loading = true;
    await this.als.setLoaded(false, 'adminSiteList');
    return this.httpService.post<any>(API.site.general.list, { owner_public_idtext: this.companieSelData.company_public_idtext })
      .then(result => {
        this.siteList = result.map(item => {
          item.status = item.status.toString();
          return item;
        }).filter(item => {
          if(this.isAdmin || (!this.isAdmin && item.status != '-5'))
            return item;
        });


        if (this.siteList.length == 1)
          this.selectSite(this.siteList[0]);
      })
      .catch(err => console.log(err))
      .finally(() => { this.als.setLoaded(true, 'adminSiteList'); this.loading = false; });
  }

  async loadSiteContent(): Promise<any> {
    this.settingsLoading = true;
    await this.als.setLoaded(false, 'adminSiteLloading');
    return this.httpService.post<any>(API.site.general.content, { site_public_idtext: this.siteSel.public_idtext, owner_public_idtext: this.companieSelData.company_public_idtext })
      .then(result => {
        this.setContentSite(result);
      })
      .catch(err => {
        this.gs.error(err);
        this.settingsLoading = false;
      })
      .finally(() => { this.als.setLoaded(true, 'adminSiteLloading'); });
  }

  async loadPersonData() {

    await this.gs.loadProfile(this.companieSelData.company_public_idtext)
    .then(async profile => {
      this.person = profile;

      await this.httpService.post<any>(API.site.general.contentGalleries, {
        owner_public_idtext: this.companieSelData.company_public_idtext,
        galleries: ["public.person.site"]
      })
      .then(result => {
        this.siteFiles = this.person.files = JSON.parse(result[0].files) || [];

      })
      .catch((err) => { this.gs.error(err); })

    })
    .finally(() => {
      this.loading = false;
    });
  }

  setTabActive(tab){
    switch(tab){
      case 'posts':
        this.ps.typesList();
      break;
    }

    this.tabActive = tab;
  }

  setContentSite(content) {

    this.siteSettingsCustom = JSON.parse(content.content);
    this.siteSettings = {};

    this.siteSettings.Address = {
      street : this.person.street,
      number : this.person.number,
      complement : this.person.complement,
      district : this.person.district,
      city : this.person.city,
      stateAcronym : this.person.stateAcronym,
      lon : this.person.lon,
      lat : this.person.lat,
    };
    this.siteSettings.SocialMedia = [];


    ['instagram','facebook','linkedin','tiktok','twitter','youtube'].map(item => {
      if(this.person[item])
        this.siteSettings.SocialMedia.push({
          type : item,
          url : this.person[item]
        });
      });

      this.siteSettings.SocialMedia.push({
        type : 'centralcorretor',
        url : this.person.person_friendly_name
      });

    

    this.siteSettings.galleries = this.siteSettingsCustom.galleries;

    delete this.siteSettingsCustom.galleries;
    delete this.siteSettingsCustom.Address;
    delete this.siteSettingsCustom.SocialMedia;

    this.setTabActive(this.siteSettingsCustom?.Modules?.Posts ? 'posts' : 'media');

    this.siteSettings.galleries = this.siteSettings.galleries?.map(item => {

      if (item.tag_id.indexOf(this.siteSel.site_id + "_") == -1)
        item.tag_id = this.siteSel.site_id + "_" + item.tag_id;

      return item;
    });

    this.mediaTags = this.siteSettings?.galleries?.map(item => {
      return {
        tag_id: item.tag_id,
        tag: item.title
      };
    }) ?? [];

    this.mediaTagsIds = this.mediaTags.map(item => item.tag_id);

    this.settingsLoading = false;

    if(this.tabActive == 'posts')
      setTimeout(() => this.refresh(), 200);

    this.updateSettings(this.siteFiles, false);

  }

  async selectSite(item) {
    this.siteSel = item;
    if (!this.person?.person_friendly_name)      
      await this.loadPersonData();

    await this.loadSiteContent();
  }

  save(ev) {

    this.httpService.post<any>(API.site.general.contentUpdate, {
      "site_public_idtext": this.siteSel.public_idtext,
      "owner_public_idtext": this.companieSelData.company_public_idtext,
      "content": {...this.siteSettings, ...this.siteSettingsCustom}
    })
      .then(result => {
        this.gs.message('Conteúdo atualizado com sucesso');
      })
      .catch(e => this.gs.error(e));

  }

  saveTemp(ev) {

    this.httpService.post<any>(API.site.admin.tempListUpdate, {})
      .then(result => {
        this.gs.message('Lista de sites temporários atualizados com sucesso');
      })
      .catch(e => this.gs.error(e));

  }


  updateSettings(result, save = true) {

    if (this.siteSettings?.galleries && !!result?.length){
      let cp = deepCopy(this.siteSettings.galleries);
      this.siteSettings.galleries = this.siteSettings?.galleries?.map(item => {


        if (!!result?.filter(rf => rf?.tags?.indexOf(item.tag_id) > -1)?.length)
          item.files = result.filter(file => file.status == 1 && !!file.tags.filter(i => i.includes(item.tag_id))?.length).sort((a, b) => a.sort - b.sort).map(file => {

            let fileUrl = file?.type.indexOf('video') > -1 ? file.variations[file.variations.length - 1].url : [BUCKETS[file.storage_bucket], file.storage_level, file.storage_path, file.variations[0].filename].join('/');
            if (fileUrl.indexOf('vimeo') > -1) {
              fileUrl = fileUrl.replace('https://vimeo.com/', '');
              fileUrl = 'https://player.vimeo.com/video/' + ((fileUrl.match(new RegExp("/", "g")) || []).length > 0 ? fileUrl.substr(0, fileUrl.indexOf('/')) : fileUrl);
            }
            
            return {
              description: file?.description || null,
              file: fileUrl,
              name : file?.name,
              ...(file?.type.indexOf('video') > -1 ? { thumb: [BUCKETS[file.storage_bucket], file.storage_level, file.storage_path, file.variations[0].filename].join('/') } : {})
            }
          });

        if (!item?.files)
          item.files = [];

        return item;
      });
      
      if(JSON.stringify(cp) != JSON.stringify(this.siteSettings.galleries))
        save = true;
    }

    this.code = this.siteSettings;
   
    if(save){
      this.gs.filesChangeSubscription.next(null);
      this.save(null);
    }
  }

  get code() {
    return JSON.stringify(this.siteSettings, null, 2);
  }

  set code(v) {
    try {
      this.siteSettings = JSON.parse(v);
    }
    catch (e) {
      //console.log('error occored while you were typing the JSON');
    };
  }

  get codecustom() {
    return JSON.stringify(this.siteSettingsCustom, null, 2);
  }

  set codecustom(v) {
    try {
      this.siteSettingsCustom = JSON.parse(v);
    }
    catch (e) {
      //console.log('error occored while you were typing the JSON');
    };
  }

  async loadPostsList(len = 20, page = 0, attr: any = {}) {

    return await this.ps.listPosts(this.siteSel.public_idtext, len, page)    
                    .finally(() => {
                      this.requestLoadingList = false;
                    });
  }



  
  getColumnHeader(columnName: string) {
    switch (columnName) {
        case 'type_id':
            return 'Tipo';
        case 'cover':
            return 'Capa';
        case 'title':
            return 'Título';
        case 'date':
            return 'Data';
        case 'source':
          return 'Fonte / Autor';
        case 'status':
            return 'Status';
    }
  }


  getColumnRowValue(element: any, columnName: string) {
    switch (columnName) {
        case 'type_id':
            return this.ps.postTypes.filter(item => item.post_type_id == element[columnName])[0]?.title;
        case 'date':
            var datePipe = new DateToString();
            return datePipe.transform(element['date']);
        case 'status':
            return this.ps.postStatus.filter(item => item.id == element[columnName])[0]?.name;
        default:
            return element[columnName];
    }
  }

  imgDidLoad(event){
    this.gs.imgDidLoad(event);
  }

  imageError(ev, data) {
    data.avatarError = true;
  }

  refresh() {
    this.listLoading = true;
    this.paginator.firstPage();

    merge(this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(():any => {
          this.als.setLoaded(false, 'postsListLoad');
          return this.loadPostsList(20, this.paginator.pageIndex + 1);
        }),
        map((data: any) => {
          this.als.setLoaded(true, 'postsListLoad');
          this.isRateLimitReached = false;
          this.postsLength = data.total.value;
          this.listLoading = false;

          data.list = data.list.map(item => {
            //item = this.adjustItem(item);
            return item;
          });

          return data.list;
        }),
        catchError((err) => {
          console.log(err);
          this.als.setLoaded(true, 'postsListLoad');
          this.isRateLimitReached = true;
          this.listLoading = false;
          return observableOf([]);
        }))
      .subscribe(data => {
        this.data.data = data;
      });
  }


  addPosts(e){
    this.gs.navigate(['openModal', 'PostsComponent'],{queryParams:{json:JSON.stringify({id:'new', site_public_idtext: this.siteSel.public_idtext})}});
  }
  
  editPosts(e, id){
    this.gs.navigate(['openModal', 'PostsComponent'],{queryParams:{json:JSON.stringify({id:id, site_public_idtext: this.siteSel.public_idtext})}});
  }

  openPost(e, data){
    this.gs.navigate(['openModal', 'PostsComponent'],{queryParams:{json:JSON.stringify({id:data.public_idtext, site_public_idtext: this.siteSel.public_idtext})}});
  }

  noSiteAction(action:String){

    var  element = document.createElement('a') as HTMLElement;
    element.setAttribute('href', 'https://wa.me/'+(this.gs.settingsData?.comercialPhone? this.gs.settingsData?.comercialPhone : '+5547991196837')+'/?text=Olá, gostaria de mais informações para '+action);
    element.setAttribute('style', 'display:none;');
    element.setAttribute('target', '_blank');
    element.click();

  }

  redeploySite(e){
    var  element = document.createElement('a') as HTMLElement;
    element.setAttribute('href', 'https://'+this.siteSel.domain+'/api/redeploy');
    element.setAttribute('style', 'display:none;');
    element.setAttribute('target', '_blank');
    element.click();
  }

}


export class PostsList {
  list: any[];
  total: Pagination;
}
